<template>
  <v-container>
    <v-card>
      <v-card-title> Seguimiento a Recursos Financieros </v-card-title>
      <v-card-text>
        <div class="Subtitle 1">
          Presupuesto General de la Nación para la implementación del Acuerdo
          Final de Paz
        </div>
        Conozca la ejecución de los recursos del Presupuesto General de la
        Nación destinados a la implementación del Acuerdo, identificados por el
        clasificador presupuestal construcción de paz.
        <br />
        <br />
        <div class="Subtitle 1">Detalle de los recursos de inversión - PGN</div>
        <v-dialog v-model="showPDF" width="800" persistent>
          <v-card>
            <v-card-text>
              <div class="vue-contentido">
                <div class="text-center" style="position: fixed; left: 50%; top: 50%;">
                    <v-progress-circular
                      v-show="!loading"
                      :size="70"
                      :width="7"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                </div>
                <iframe width="100%" height="800" :src="ruta" frameborder="0"  allowfullscreen v-on:load="loading=true;"></iframe>
              </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="CerrarPdf()">Cerrar</v-btn>
          </v-card-actions>
          </v-card>
        </v-dialog>
        <v-flex row class="container">
          <v-flex xs12 sm6 md3 class="mx-1">
            <v-select
              :items="DataPuntos"
              v-model="puntoselected"
              item-text="nombre"
              item-value="idpunto"
              label="Punto del acuerdo"
              sort-by="idpunto"
              @change="filterPunto"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 md3 class="mx-1">
            <v-select
              :items="DataSector"
              v-model="sectorselected"
              item-text="sector"
              item-value="sector"
              label="Sector"
              @change="filterSector"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 md3 class="mx-1">
            <v-select
              :items="DataEntidad"
              v-model="entidadselected"
              item-text="entidad"
              item-value="entidad"
              label="Entidad"
              @change="filterEntidad"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm5 md2 class="mx-1">
            <v-select
              :items="DataVigencia"
              v-model="vigenciaselected"
              item-text="vigencia"
              item-value="vigencia"
              label="Vigencia"
              @change="filterVigencia"
            ></v-select>
          </v-flex>
        </v-flex>
        <v-flex>
          <v-data-table
            :headers="HeaderPresupuestos"
            :items="DataPresupuestos.filter(v => v.vigencia <= 2023)"
            item-key="idpresupuesto"
            :custom-filter="customFilter"
            :items-per-page="10"
            class="elevation-1"
            :no-data-text="gnodata"
          >
              <template v-slot:[`item.vigentepolitica`]="{ item }">
                {{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(item.vigentepolitica) }}
              </template> 
              <template v-slot:[`item.compromisopolitica`]="{ item }">
                {{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(item.compromisopolitica) }}
              </template>
              <template v-slot:[`item.obligacionpolitica`]="{ item }">
                {{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(item.obligacionpolitica) }}
              </template>

              <template v-slot:item.action="{ item }">
                <a :href="item.ruta" style="text-decoration: none;">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small class="mr-2" v-on="on" @click="LoadProyectoSIUFP(item)" >mdi-eye</v-icon>
                    </template>
                    <span>Ver</span>
                  </v-tooltip>
                </a>
              </template>

              <template v-slot:footer>
                  <div id="div1" style="width: 100%; align: right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <download-excel
                          id="div2"
                          style="width: 100%; text-align: right"
                          v-show="DataPresupuestos.length > 0"
                          class="btn btn-default"
                          :data="DataPresupuestos.filter(v => v.vigencia <= 2023)"
                          :exportFields="exportable"
                          name="seguimiento_inversion.xls"
                          type="xls"
                          worksheet="Información"
                          :title= dataForExcel
                          
                        >
                          <v-icon
                            color="secondary"
                            v-on="on"
                            large
                            elevation="2"
                            >mdi-file-download-outline</v-icon
                          >
                        </download-excel>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </div>
              </template>

          </v-data-table>
        </v-flex>
        <v-flex>


        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "recursos_inversion",
  data() {
    return {
      ruta: null,
      showPDF:false,
      path: process.env.VUE_APP_REPORT,
      loading:false,
      dataForExcel: ["Reporte detallado - Presupuesto General de la Nación - Inversion ( Fuente SPI - Trazador construccion de Paz).", 
      " Para el análisis y uso de la información del trazador revisar documento metodológico en el menú Ayuda de SIIPO 2.0"],
      HeaderPresupuestos: [
        { text: "Nombre de proyecto", value: "nombreproyecto", align: "left" },
        { text: "Punto/Pilar", value: "componente", align: "left" },
        { text: "Apropiación vigente paz",
          value: "vigentepolitica",
          align: "right",
          dataType: "Money",
        },
        {
          text: "Comprometido paz",
          value: "compromisopolitica",
          align: "right",
        },
        { text: "Obligado paz", value: "obligacionpolitica", align: "right" },
        { text: "Acciones", value: "action", align: "center", sortable: false, width: "30px"},
      ],
      exportable: {
        Vigencia: "vigencia",
        Mes: "periodo",
        Sector: "sector",
        Entidad: "entidad",
        "Código BPIN": "codigoproyecto",
        "Nombre del Proyecto": "nombreproyecto",
        Trazador: "politica",
        Punto: "nombrePunto",
        Pilar: "nombrePilar",
        "Punto/Pilar": "componente",
        // "Comprometido paz": { 
        //     field: "compromisoproyecto", 
        //     callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value)}`; },
        //                     },
        // "Obligado paz": { 
        //     field: "obligacionproyecto", 
        //     callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value)}`; },
        //                     },
        // "Inicial Política": { 
        //     field: "inicialpolitica", 
        //     callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value)}`; },
        //                     },
        "Vigente Política":{
            field: "vigentepolitica", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value)}`; },
        },
        "Compromisos Política": {
            field: "compromisopolitica", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value)}`; },
        }, 
        "Obligaciones Política": {
            field: "obligacionpolitica", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value)}`; },
        },
        "Pagos Política": {
            field: "pagopolitica", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value)}`; },
        },        
        "Fecha Corte": "fechacorte"
      },
      DataPresupuestos: [],
      DataPuntos: [],
      DataSector: [],
      DataEntidad: [],
      DataVigencia: [],
      puntoselected: "",
      sectorselected: "",
      entidadselected: "",
      vigenciaselected: 0,
      filter: "",
      filters: { idpunto: "", sector: "", entidad: "", vigencia: "" },
    };
  },
  created() {
    this.get_puntos();
    this.get_sectorspi();
    this.get_entidadspi();
    this.get_vigencias();
    this.get_presupuestos();
  },
  mounted() {
    if (localStorage.vigenciaselected != undefined)
    {
      this.vigenciaselected = parseInt(localStorage.vigenciaselected)
    }
  },  
  methods: {
    ...mapActions([
      "get_puntos",
      "get_sectorspi",
      "get_entidadspi",
      "get_vigencias",
      "get_presupuestos",
    ]),
    customFilter(items, filters) {
      if (filters.idpunto != "") {
        if (filters.idpunto != 0)
          items = items.filter((record) => {
            return record.idpunto == filters.idpunto;
          });
      }
      if (filters.sector != "") {
        if (filters.sector != "TODOS")
          items = items.filter((record) => {
            return record.sector.toLowerCase() == filters.sector.toLowerCase();
          });
      }
      if (filters.entidad != "") {
        if (filters.entidad != "TODAS")
          items = items.filter((record) => {
            return (
              record.entidad.toLowerCase() == filters.entidad.toLowerCase()
            );
          });
      }
      if (filters.vigencia != "") {
        if (filters.vigencia != "TODOS")
          items = items.filter((record) => {
            return record.vigencia == filters.vigencia;
          });
      }

      return items;
    },
    filterPunto(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        idpunto: val,
      });
      this.DataPresupuestos = this.customFilter(
        this.glistapresupuestos,
        this.filters
      );
    },
    filterSector(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        sector: val,
      });
      this.DataPresupuestos = this.customFilter(
        this.glistapresupuestos,
        this.filters
      );
      this.filterEntidadSector()
    },
    filterEntidad(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        entidad: val,
      });
      this.DataPresupuestos = this.customFilter(
        this.glistapresupuestos,
        this.filters
      );
    },
    filterEntidadSector(){
        this.DataEntidad = [];
        let tmpTodos = Object.assign({}, this.gentidadesspi[0]);
        tmpTodos.entidad = "TODAS";
        let entidaesfiltradas
        let sectorfilter = this.sectorselected
        if (sectorfilter == "TODOS" || sectorfilter == '' )
        {
          entidaesfiltradas = this.gentidadesspi

        } else
        {
          entidaesfiltradas = this.gentidadesspi.filter((record) => {
            return record.sector == sectorfilter;
          });
        }
        this.DataEntidad = entidaesfiltradas;
        this.DataEntidad.unshift(tmpTodos);
    },
    filterVigencia(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        vigencia: val,
      });
      this.DataPresupuestos = this.customFilter(
        this.glistapresupuestos,
        this.filters
      );    
      localStorage.setItem("vigenciaselected", this.vigenciaselected);
    },
    LoadProyectoSIUFP(item) {
      //this.ruta = 'http://vsiipoprfe:8080/Formularios/VisorSUIFP?BPIN='+ item.codigoproyecto+'&vigencia='+item.vigencia+'&periodo='+item.periodo+''
      this.ruta = this.path + 'Formularios/VisorSUIFP?BPIN='+ item.codigoproyecto+'&vigencia='+item.vigencia+'&periodo='+item.periodo+''
      this.showPDF = true;
      this.loading = false;
    },
    CerrarPdf(){
      this.ruta = ''
      this.showPDF = false;
      this.loading = false;
    },

  },
  computed: {
    ...mapGetters([
      "gpuntos",
      "gsectoresspi",
      "gentidadesspi",
      "gvigencias",
      "glistapresupuestos",
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata", "glogo"]),
  },
  watch: {
    gpuntos: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.DataPuntos = [];
        let tmpTodos = Object.assign({}, this.gpuntos[0]);
        tmpTodos.idpunto = 0;
        tmpTodos.nombre = "TODOS";
        this.DataPuntos = this.gpuntos;
        this.DataPuntos.unshift(tmpTodos);
      }
    },
    gsectoresspi: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.DataSector = [];
        let tmpTodos = Object.assign({}, this.gsectoresspi[0]);
        tmpTodos.sector = "TODOS";
        this.DataSector = this.gsectoresspi;
        this.DataSector.unshift(tmpTodos);
      }
    },
    gentidadesspi: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.filterEntidadSector()
      }
    },
    gvigencias: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.DataVigencia = [];
        let tmpTodos = Object.assign({}, this.gvigencias[0]);
        tmpTodos.vigencia = "TODOS";
        this.DataVigencia = this.gvigencias.filter(p=> p.vigencia <= 2023);
        this.DataVigencia.unshift(tmpTodos);
      }
    },
    glistapresupuestos: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        if (this.vigenciaselected == 0){
          this.DataPresupuestos = this.glistapresupuestos.filter(v => v.vigencia <= 2023);
          console.log('this.DataPresupuestos', this.DataPresupuestos)
        }
        else
          this.filterVigencia(this.vigenciaselected)
      }
    },

  },
};
</script>